import React, { useState,useEffect } from 'react';
import { NavLink,useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,dynamicUrl,formatDate } from './Function';
import { useDynamicLink } from './DynamicUse';
import { Row,Col,Card,Table,Form,Placeholder,Button, Spinner } from 'react-bootstrap';
const EventsDepartment = ({ sdId,cardHeading }) => 
{
    const navigate = useNavigate();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(228);
    const[Events,setEvents]=useState([]);
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const Department = Number(sdId) || 0;
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    const EventsArchive = (sp,sdId) => 
    {
        localStorage.setItem('setDepartment',sdId);
        navigate(dynamicUrl(sp));
    };
    useEffect(()=>
    {
        fetchEvents(true);
        // eslint-disable-next-line
    },[sdId,cardHeading])
    const fetchEvents = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);  // Reset Rows if this is a new search
            setEvents([]);  // Clear previous results
        }
        try
        {
            setLoading(true);
            var scId = 0;
            var keywordText = keyword || 'none';
            const currentRows = isReset ? 0 : Rows;
            const { startDate, endDate } = setDateRange(year, month, 0, 0, 1);
            const callApi = global.config.API_URL + `events/list/${Department}/${scId}/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('fetchEvents : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) 
            {
                setEvents(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                setRows(currentRows + 30);             
                setLoadMore(true);
            } 
            else 
            {
                setLoadMore(false);
            }
            if (global.config.IsPrint) console.info('fetchEvents : Result', result);
        } 
        catch (error) 
        {
            console.error('fetchEvents : Error', error.message);            
        }
        finally
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (!keyword && year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        fetchEvents(true);
    }
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1500">{cardHeading}</Card.Header>
            <Card.Body>
                <Card className='mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{t('FilterYear')}</option>
                                        {setYearList(0, 0).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{t('FilterMonth')}</option>
                                        {setMonthList().map(({ value, label }) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                    <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>                    
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                <thead>
                    <tr>
                        <th className='w-50'>{t('Title')}</th>
                        <th>{t('Department')}</th>
                        <th>{t('Duration')}</th>
                        <th>{t('Download')}</th>
                    </tr>
                </thead>
                {isLoading ? (
                <tbody>
                {[...Array(10)].map((_,index) => (
                    <tr key={index}> 
                        <th className="table-success"><Placeholder xs={10} bg="success" /></th>
                        <td className="text-center"><Placeholder xs={10} /></td>
                        <td><Placeholder xs={10} bg="dark" /></td>
                        <td className="text-center">
                            <Button className="btn btn-light w-100"><Placeholder xs={10} bg="dark" /></Button>
                        </td>                            
                    </tr>
                ))}
                </tbody>
                ) : (
                <React.Fragment>
                    {Events.length > 0 ? (
                    <tbody>
                    {Events.map((se,index)=>(
                        <tr key={index}>
                            <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></th>
                            <td className="text-center">{(appLanguage === 'hi' && se.departments.sd_name_hi) ? se.departments.sd_name_hi : se.departments.sd_name}</td>
                            <td className="text-center">{formatDate(se.se_start_duration)} TO {formatDate(se.se_end_duration)}</td>
                            <td className="text-center">
                                <NavLink to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/event/details/${se.se_htaccess}`} className="btn btn-light" target='_blank' rel="noopener noreferrer">
                                    {t('ViewDownload')}
                                </NavLink>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    ) : (
                    <tbody>
                        <tr>
                            <td colSpan={4} className='text-center'>{t('NoResult')}</td>
                        </tr>
                    </tbody>
                    )}
                </React.Fragment> 
                )}    
                </Table>   
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between bg-white'>
                {dynamicLinkData && dynamicLinkData.map((sp,index)=>(
                    <Button key={index} onClick={() => EventsArchive(sp,sdId)} variant='info'>
                        {t('Archives')}
                    </Button>
                ))}
                {isLoadMore &&
                <Button variant='info' onClick={() => fetchEvents(false)} disabled={isLoading}>
                    {isLoading ? (
                    <React.Fragment>
                        <Spinner animation="grow" variant="light" size="sm" />
                        <Spinner animation="grow" variant="danger" size="sm" />
                        <span className='ms-2'>{t('PleaseWait')}</span>
                    </React.Fragment>
                    ) : t('LoadMore')}
                </Button>}                
            </Card.Footer>
        </Card>
    );
}
export default EventsDepartment;